import React from 'react'

import Box from '@ilg-totallymoney/ui/components/Box'
import Button from '@ilg-totallymoney/ui/components/Button'
import Flex from '@ilg-totallymoney/ui/components/Flex'
import LinkButton from '@ilg-totallymoney/ui/components/LinkButton'
import Row from '@ilg-totallymoney/ui/components/Row'
import Stack from '@ilg-totallymoney/ui/components/Stack'
import Text from '@ilg-totallymoney/ui/components/Text'
import Icon from '@ilg-totallymoney/ui/icons/Icon'
import theme from '@ilg-totallymoney/ui/theme'

const LittleLoansApplyButtons = ({
    applicationUrl,
    isLoading,
    onApply,
    onMoreInfoClick,
}: {
    applicationUrl: string
    isLoading: boolean
    onApply: () => void
    onMoreInfoClick: () => void
}) => (
    <Stack space="space15">
        <LinkButton
            href={applicationUrl}
            isExternalLink={true}
            text="Get your quote"
            variant="primary"
            onClick={onApply}
            loading={isLoading}
        />
        <Row justifyContent="center" alignItems="center" space="space05">
            <Icon color={theme.teal140} icon="offersCheckMark" size={16} />
            <Text variant="80" weight="bold">
                No impact on your credit score
            </Text>
        </Row>
        <Flex justifyContent="center">
            <Button variant="tertiaryTransparent" onClick={onMoreInfoClick}>
                More info
            </Button>
        </Flex>
    </Stack>
)

export default LittleLoansApplyButtons
